import { create } from "zustand";
import { AgendaSlice, createAgendaStore } from "./agenda.store";

interface AgendaStoreType extends AgendaSlice {}

export const useAgendaStore = create<AgendaStoreType>((...args) => ({
	...createAgendaStore(...args),
}));
